import { create } from "zustand";
import type { ClientOpportunitiesState } from "./types";

const useClientOpportunitiesStore = create<ClientOpportunitiesState>((set) => ({
    clientOpportunities: [],
    setClientOpportunities: (data) => set({ clientOpportunities: data }),
}));

export { useClientOpportunitiesStore };

